import {SanityBlockSectionHeader} from '~/types/sanityTypes';
import {useSanityClient} from '~/lib/utils';
import urlBuilder from '@sanity/image-url';

export function BlockSectionHeader({
  blockContent,
}: {
  blockContent: SanityBlockSectionHeader;
}) {
  return (
    <>
      <div className="block-section-header">
        <div className="container">
          <h2 className="text-4xl leading-[1rem] md:text-5xl mt-12 md:leading-[2.8rem] text-outline-black text-transparent font-clash uppercase">
            {blockContent.title}
          </h2>
          <div className="w-full aspect-[3/1] overflow-hidden">
            <img
              src={urlBuilder(useSanityClient)
                .image(blockContent.image)
                .width(1600)
                .fit('max')
                .auto('format')
                .url()}
              alt={blockContent.title + ' kuva'}
              loading="lazy"
              style={{
                objectFit: 'cover',
                objectPosition: 'center',
                height: '100%',
                width: '100%',
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
